import {
  expenseRefundCategories,
  expenseAndRefundAllocationKeys,
  anlageVCategories,
  allocationKeys,
} from "./_finance";

import routes from "./_routes";

export default initAlpineComponents = (Alpine) => {
  Alpine.data("fullscreenLoader", () => ({
    timerID: undefined,
    showLoader(delay = 0) {
      var el = document.querySelector(".page-loader");
      // check first if we have custom page-loader in the current page
      const customLoader = document.querySelector(".custom-page-loader");
      if (customLoader) {
        el = customLoader;
      }
      this.timerID = setTimeout(() => {
        el.style.display = "flex";
      }, delay);
    },
    hideLoader() {
      var el = document.querySelector(".page-loader");
      // check first if we have custom page-loader in the current page
      const customLoader = document.querySelector(".custom-page-loader");
      if (customLoader) {
        el = customLoader;
      }
      clearTimeout(this.timerID);
      el.style.display = "none";
    },
  }));

  Alpine.data("tooltip", () => ({
    open: false,
    toggle() {
      this.open = !this.open;
    },
  }));

  Alpine.data("dateMath", () => ({
    addYear(date) {
      const parts = date.split("-");
      if (parts.length != 3) {
        return "";
      }
      const year = parseInt(parts[0]) + 1;
      const month = parseInt(parts[1]) - 1;
      const day = parseInt(parts[2]);
      let newdate = new Date(year, month, day);
      if (!newdate) {
        return "";
      }
      return newdate.toISOString().slice(0, 10);
    },
  }));

  Alpine.data("rentCalc", () => ({
    calc(total, multiplier) {
      return Number(total * multiplier).toLocaleString("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    depositCalc(total, multiplier) {
      return this.calc(Math.floor(total * multiplier), 1);
    },
    monthlyRent(rent, utilityCost, heatingCost) {
      return this.calc(rent + utilityCost + heatingCost, 1);
    },
    yearlyColdRent(rent) {
      return this.calc(rent, 12);
    },

    clamp(value, min, max) {
      if (value < min) {
        return min;
      } else if (value > max) {
        return max;
      }

      return value;
    },

    clampInput(input) {
      const min = parseFloat(input.getAttribute("min"));
      const max = parseFloat(input.getAttribute("max"));
      const value = Math.floor(parseFloat(input.value));

      if (isNaN(value)) {
        input.value = "";
        return "";
      }

      input.value = this.clamp(value, min, max);
      return input.value;
    },
  }));

  Alpine.data("complexSelectOption", (el) => ({
    labels: {},
    expanded: false,
    init() {
      el.querySelectorAll(".complex-select-option").forEach((opt) => {
        this.labels[opt.dataset.value] = opt.dataset.label;
      });
    },
    toggleOption(inputEl) {
      if (this.checkedElements.includes(inputEl.value)) {
        this.checkedElements = this.checkedElements.filter(
          (v) => inputEl.value !== v
        );

        const type = inputEl.dataset.type;
        if (type === "rentalobject") {
          this.filters.rentalObjects = this.filters.rentalObjects.filter(
            (v) => inputEl.value !== v
          );
        } else {
          this.filters.buildings = this.filters.buildings.filter(
            (v) => inputEl.value !== v
          );
        }
      } else {
        const type = inputEl.dataset.type;
        if (type === "rentalobject") {
          this.filters.rentalObjects.push(inputEl.value);
        } else {
          this.filters.buildings.push(inputEl.value);
        }
        this.checkedElements.push(inputEl.value);
      }
    },
    getLabels() {
      if (this.checkedElements.length === 0) {
        return "Alle";
      }
      return this.checkedElements.map((v) => this.labels[v]).join(", ");
    },
  }));

  Alpine.data(
    "filterContent",
    (type, description, buildingId, rentalObjectId, tenancyId, amount) => ({
      shouldShow() {
        return (
          (this.filters.search === "" ||
            description
              .toLowerCase()
              .includes(this.filters.search.toLowerCase()) ||
            amount
              .replace(".", "")
              .includes(this.filters.search.toLowerCase()) ||
            amount.includes(this.filters.search.toLowerCase())) &&
          (this.filters.type == "" || this.filters.type == type) &&
          ((this.filters.buildings.length == 0 &&
            this.filters.rentalObjects.length == 0) ||
            this.filters.buildings.includes(buildingId) ||
            this.filters.rentalObjects.includes(rentalObjectId))
        );
      },
    })
  );

  Alpine.data("rentPaymentEntry", (routeBase, status, id, cb) => ({
    status: status,
    id: id,
    routeBase: routeBase,
    updateStatus() {
      fetch(this.routeBase.replace("{id}", this.id), {
        method: "POST",
      }).then((res) => {
        if (res.status === 200) {
          this.status = "green";
        }

        if (cb) {
          cb(this.status);
        }
      });
    },
  }));

  Alpine.data(
    "scanExpense",
    (
      allocationKey,
      description,
      amount,
      category,
      invoiceDate,
      billingPeriod,
      selectedBuildingId,
      selectedRentalObjectId,
      selectedTenancyId,
      rentalObjects,
      tenancies
    ) => ({
      expenseCategories: expenseRefundCategories,
      expenseAndRefundAllocationKeys,
      anlageVCategories,
      allocationKeys,
      async submitForm(formId) {
        const form = document.getElementById(formId);
        const formData = new FormData(form);

        this.loading = true;
        try {
          const response = await fetch(form.action, {
            method: "POST",
            body: formData,
          });
          const data = await response.json();

          this.loading = false;
          const expense = data.expense;
          const file = data.file;

          this.category = expense.category;
          this.amount = expense.amount;
          this.description = expense.name;
          this.date = expense.invoiceDate;
          this.billingPeriod = expense.billingPeriod;

          if (data.billingPeriod < new Date().getFullYear() - 3) {
            this.scanResultMessage = "old";
            this.billingPeriod = new Date().getFullYear();
            this.date = new Date().toISOString().slice(0, 10);
          }

          if (file && file.token) {
            window.handleNewFileToken(
              file,
              "file",
              document.getElementById("file")
            );
          }
        } catch (error) {
          console.error("Error submitting form:", error);
        }
      },
      loading: false,
      allocationKey: allocationKey,
      scanResultMessage: "",
      description: description,
      amount: amount,
      date: invoiceDate,
      category: category,
      invoiceDate: invoiceDate,
      billingPeriod: billingPeriod,
      selectedBuildingId: selectedBuildingId,
      selectedTenancyId: selectedTenancyId,
      selectedRentalObjectId: selectedRentalObjectId,
      rentalObjects: rentalObjects,
      tenancies: tenancies,

      get filteredTenanciesOptions() {
        if (this.selectedBuildingId === -1) {
          return this.tenancies;
        }
        return this.tenancies.filter(
          (opt) => opt.buildingId == this.selectedBuildingId
        );
      },
      get filteredRentalObjectsOptions() {
        if (this.selectedBuildingId === -1) {
          return this.rentalObjects;
        }
        return this.rentalObjects.filter(
          (opt) => opt.buildingId == this.selectedBuildingId
        );
      },
    })
  );
  Alpine.data("dynamicSelect", (allOptions) => ({
    selectedBuildingId: -1,
    init() {
      // Convert string building IDs to numbers for comparison
      this.allOptions = allOptions.map((opt) => ({
        ...opt,
        buildingId: parseInt(opt.buildingId),
      }));
    },
  }));

  Alpine.data("asyncJobChecker", (asyncJobStatus, asyncJobID, onComplete = () => {
    window.location.reload();
  }) => ({
    asyncJobID: asyncJobID,
    asyncJobStatus: asyncJobStatus,
    pollingInterval: null,
    init() {
      if (this.asyncJobStatus === "running") {
        this.startPolling();
      } else {
        console.log("Job was already complete, running oncomplete callback");
        onComplete(this.asyncJobStatus);
      }
    },
    startPolling() {
      this.pollingInterval = setInterval(() => {
        this.checkStatus();
      }, 5000);
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    checkStatus() {
      fetch(`${routes.asyncJobStatusURL}${this.asyncJobID}`)
        .then((res) => res.json())
        .then((data) => {
          this.asyncJobStatus = data.status;
          if (this.asyncJobStatus !== "running") {
            this.stopPolling();
            console.log("Job completed, running oncomplete callback");
            onComplete(this.asyncJobStatus);
          }
        })
        .catch((err) => {
          console.error("Error checking async job status:", err);
          this.stopPolling();
        });
    },
  }));

  Alpine.data("addressAutocomplete", (apiKey, street, zip, city, country) => ({
    street: street,
    zip: zip,
    city: city,
    country: country,
    predictions: [],
    apiKey: apiKey,
    sessionId: null,
    debounceTimer: null,
    showPredictions: false,

    init() {
      this.sessionId = this.generateSessionId();
      this.$watch("predictions", () => {
        this.$nextTick(() => {
          this.updateDropdownPosition();
        });
      });
    },

    updateDropdownPosition() {
      if (!this.$refs.input || !this.$refs.dropdown) return;

      const inputRect = this.$refs.input.getBoundingClientRect();
      this.$refs.dropdown.style.display = "block";
      this.$refs.dropdown.style.position = "fixed";
      this.$refs.dropdown.style.top = `${inputRect.bottom}px`;
      this.$refs.dropdown.style.left = `${inputRect.left}px`;
      this.$refs.dropdown.style.width = `${inputRect.width}px`;
    },

    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => func.apply(this, args), wait);
      };
    },

    extractStreetNumberSuffix(userInput) {
      const regex = /(\d+)\s*([a-zA-Z])\s*$/; 
      const match = userInput.match(regex);

      if (match) {
        return {
          baseNumber: match[1], // "49"
          suffix: match[2],     // "a"
          fullNumber: match[0]  // "49a"
        };
      }
      return null;
    },

    async autocompleteStreet() {
      if (!this.street) {
        this.predictions = [];
        this.showPredictions = false;
        return;
      }

      const url = "https://places.googleapis.com/v1/places:autocomplete";
      const headers = {
        "Content-Type": "application/json",
        "X-Goog-Api-Key": this.apiKey,
        "X-Goog-FieldMask":
          "suggestions.placePrediction.place,suggestions.placePrediction.placeId,suggestions.placePrediction.text",
      };

      const body = {
        input: this.street,
        includedRegionCodes: ["de"],
        includedPrimaryTypes: ["street_address"],
        sessionToken: this.sessionId,
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(body),
        });

        const data = await response.json();
        if (data.suggestions) {
          this.predictions = data.suggestions
            .filter((suggestion) => suggestion.placePrediction)
            .map((suggestion) => ({
              id: suggestion.placePrediction.placeId,
              displayName: {
                text: suggestion.placePrediction.text.text,
              },
            }));
          this.showPredictions = this.predictions.length > 0;
        } else {
          this.predictions = [];
          this.showPredictions = false;
        }
      } catch (error) {
        console.error("Error fetching autocomplete:", error);
        this.predictions = [];
        this.showPredictions = false;
      }
    },

    get debouncedAutocomplete() {
      return this.debounce(this.autocompleteStreet, 500);
    },

    async selectPrediction(prediction) {
      this.predictions = [];
      this.showPredictions = false;
      try {
        const url = `https://places.googleapis.com/v1/places/${prediction.id}?fields=formattedAddress,addressComponents`;
        const headers = {
          "X-Goog-Api-Key": this.apiKey,
        };
        const response = await fetch(url, {
          method: "GET",
          headers: headers,
        });
        const placeData = await response.json();
        this.extractAddressComponents(placeData.addressComponents, prediction.displayName.text);
      } catch (e) {
        console.error("Error getting place details: ", e);
      }
    },

    extractAddressComponents(components, selectedDisplayName) {

      this.zip = "";
      this.city = "";
      let streetName = "";
      let streetNumber = "";

      const selectedStreet = selectedDisplayName.split(",")[0];
      let extractedStreetNumber = this.extractStreetNumberSuffix(selectedStreet);
      if (extractedStreetNumber != null) {
        streetNumber = extractedStreetNumber.fullNumber;
      }
      for (const component of components) {
        if (component.types.includes("postal_code")) {
          this.zip = component.shortText;
        } else if (component.types.includes("locality")) {
          this.city = component.longText;
        } else if (component.types.includes("route")) {
          streetName = component.longText;
        } else if (component.types.includes("street_number") && extractedStreetNumber == null) {
          streetNumber = component.shortText;
        } else if (component.types.includes("country")) {
          this.country = component.longText;
        }
      }
      this.street = `${streetName} ${streetNumber}`;
    },

    generateSessionId() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
  }));

  Alpine.data("csvDownload", (period) => ({
    period,
    loading: false,
    error: "",
    async submit(form, submitter) {
      this.loading = true;
      this.error = "";
      try {
        const action = submitter?.getAttribute("formaction") || form.action;
        const response = await fetch(action, {
          method: "POST",
          credentials: "same-origin",
          body: new URLSearchParams(new FormData(form)),
        });

        // errors (incl. "no data") come back as JSON, the file as text/csv
        const contentType = response.headers.get("Content-Type") || "";
        if (contentType.includes("application/json")) {
          const data = await response.json();
          this.error = data.error || form.dataset.genericError;
          return;
        }
        if (!response.ok) {
          this.error = form.dataset.genericError;
          return;
        }

        const disposition = response.headers.get("Content-Disposition") || "";
        const match = disposition.match(/filename="?([^"]+)"?/);
        const url = URL.createObjectURL(await response.blob());
        const a = document.createElement("a");
        a.href = url;
        a.download = match ? match[1] : "export.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error("csv download failed:", e);
        this.error = form.dataset.genericError;
      } finally {
        this.loading = false;
      }
    },
  }));
};
